import React, {useContext} from 'react'
import {
    Typography,
    FormControlLabel,
    Radio,
    FormControl,
    FormLabel,
    Stack,
    TextField,
} from '@mui/material'
import { Trans } from 'react-i18next'
import {
    ComplaintTypeState,
    LocationOptions,
    YesNoOptions,
} from '../../../contexts/types'
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

type OtherOptionsProps = {
    selectedOption: string
    handleTextFieldChange: (
        fieldName: keyof ComplaintTypeState,
        value: string
    ) => void
    otherExplanation: string
    otherExplanationError: string
    wasPatientInvolved: YesNoOptions
    eventOccurrence: LocationOptions
}

const OtherOptions: React.FC<OtherOptionsProps> = ({
    selectedOption,
    handleTextFieldChange,
    otherExplanation,
    otherExplanationError,
    wasPatientInvolved,
    eventOccurrence,
}) => {
    const { t, tns, orgIdentifier } = useContext(OrgCustomizationContext)
    const handleChange = (
        e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        handleTextFieldChange('otherExplanation', e.target.value)
    }

    return (
        <>
            {/* Esthetic */}
            <Stack spacing={0}>
                {(orgIdentifier !== 'Nobel' || 
                    (orgIdentifier === 'Nobel' && wasPatientInvolved === 'YES' &&
                    (eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ||
                        eventOccurrence === '5_CLINIC_AFTER_PROCEDURE')))
                    && (
                    <Typography
                        variant='body1'
                        color='secondary.contrastText'
                        sx={{ pt: 2 }}
                    >
                        <Trans i18nKey={tns('cti_complaint_other')}>
                            -
                            <Typography
                                component='span'
                                sx={{ color: 'primary.main' }}
                            >
                                -
                            </Typography>
                            -
                        </Trans>
                    </Typography>
                )}

                {wasPatientInvolved === 'YES' &&
                (eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ||
                    eventOccurrence === '5_CLINIC_AFTER_PROCEDURE') ? (
                    <FormControlLabel
                        value='TRAUMA'
                        control={<Radio />}
                        label={t('cti_option_trauma') as string}
                    />
                ) : null}
                
                {orgIdentifier !== 'Nobel' && (
                    <>
                        <FormControlLabel
                            value='OTHER_DEFICIENCIES'
                            control={<Radio />}
                            label={t('cti_option_other_deficiencies') as string}
                        />

                        {selectedOption === 'OTHER_DEFICIENCIES' && (
                            <FormControl sx={{ pt: 0 }}>
                                <FormLabel sx={{ mb: 1 }}>
                                    {t('cti_please_explain')}:
                                </FormLabel>
                                <TextField
                                    multiline
                                    minRows={2}
                                    maxRows={4}
                                    sx={{ maxWidth: '40rem', mb: 2 }}
                                    error={!!otherExplanationError}
                                    helperText={otherExplanationError}
                                    value={otherExplanation}
                                    onChange={handleChange}
                                />
                                {/* <FormHelperText error={!!otherExplanationError}>
                                    {otherExplanationError}
                                </FormHelperText> */}
                            </FormControl>
                        )}
                    </>
                )}
            </Stack>
        </>
    )
}

export default OtherOptions
